import cn from "classnames";
import styles from "./Tabs.module.scss";

interface ITabControlProps {
  className?: string;
}

export const TabControlLabel: RFC<ITabControlProps> = ({ className, children }) => {
  return <span className={cn(styles.controlLabel, className)}>{children}</span>;
};

TabControlLabel.displayName = "TabControlLabel";
